export default {
  REGIONS: {
    hn: 'Hà Nội',
    hcm: 'Hồ Chí Minh',
    'vc-hanoi': 'VC Hà Nội'
  }
}
